import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { AveriasService } from 'src/app/servicios/averias.service';
import { PerfilesUsuarioService } from 'src/app/servicios/perfiles-usuario.service';
import { SnackBarComponent } from '../../snack-bar/snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { altaUsuario } from 'src/app/entidades/entidades.component';
import { PasswordValidatorService } from 'src/app/servicios/password-validator.service';
//import {SharedModule} from '../../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatIconModule } from '@angular/material/icon';
@Component({
    selector: 'app-nuevo-usuario',
    templateUrl: './nuevo-usuario.component.html',
    styleUrls: ['./nuevo-usuario.component.css'],
    standalone: true,
    imports: [FormsModule, MatIconModule, CommonModule, NbCardModule, NbIconModule, DropdownModule, MatCardModule, MatFormFieldModule, MatInputModule, AngularSlickgridModule, NbTabsetModule, MatDatepickerModule, MatNativeDateModule, NbSelectModule, NbTreeGridModule, SpinnerComponent, MultiSelectModule],
})
export class NuevoUsuarioComponent implements OnInit {

  @Output() cerrar = new EventEmitter<any>();
  @Output() cerrarUpdate = new EventEmitter<any>();
  modalRef: BsModalRef;
  idCliente: number;
  durationInSeconds = 3;
  empresaSelected;
  perfilSelected: number = 0;
  clienteSelected;
  nombre = "";
  apellido = "";
  email = "";
  dni;
  nombreDeUsuario = "";
  contrasenia = "";
  REcontrasenia = "";
  empresas = [];
  perfiles = [];
  getPerfiles = [];
  perfilesOperador = [];
  showPasswordPw = false;
  showPasswordREPw = false;
  misEmpresas = [];
  showSpinner = false;

  showPassTooltip: boolean = false

  perfilUsuario = localStorage.getItem('perfil')

  constructor(private svcAverias: AveriasService,
    private svcUsuarios: PerfilesUsuarioService,
    private _snackBar: MatSnackBar,
    public passValidator: PasswordValidatorService
  ) { }


  ngOnInit(): void {
    this.idCliente = Number(localStorage.getItem("idCliente"));
    this.llenarEmpresas();
    this.traerPerfiles();
    this.traerPerfilesOperador();
  }
  // --
  @ViewChild('altaUsuario') form: any

  ngAfterViewInit() {
    this.form.control.valueChanges
      .subscribe(({ contrasenia, REcontrasenia }: altaUsuario) => {
        this.passValidator.checkPassword(contrasenia, REcontrasenia)
      });
  }

  llenarEmpresas() {
    this.svcAverias.getOperadoresPorCliente(this.idCliente).subscribe(data => {
      this.empresas = [{ value: 0, label: "Ninguna" }];
      this.misEmpresas = data;
      this.misEmpresas.forEach(e => {
        this.empresas.push({
          value: e.id,
          label: e.descripcion
        })
      });
    });
  }

  traerPerfiles() {
    this.svcUsuarios.getPerfiles().subscribe(data => {
      this.getPerfiles = data.content;
      this.llenarPerfiles();
    });
  }
  llenarPerfiles() {
    this.perfiles = [];
    // let perfilesFilter = this.getPerfiles.filter(e => e.id !== Number(localStorage.getItem('idCliente')) && e.id !== 24)
    // let perfilesFilter = this.getPerfiles.filter(e => e.id !== Number(localStorage.getItem('idCliente')))
    this.getPerfiles.forEach(e => {
      if (e.cliente && e.descripcion !== this.perfilUsuario &&
        e.descripcion !== 'Soporte VCA' && e.descripcion !== 'Consultas') {
        this.perfiles.push({
          value: e.id,
          label: e.descripcion
        })
      }
    });
  }
  traerPerfilesOperador() {
    this.svcUsuarios.getPerfiles().subscribe(data => {
      this.perfilesOperador = data.content;
    });
  }
  llenarPerfilesOperador() {
    this.perfiles = [];
    if (this.empresaSelected != 0) {
      this.perfilesOperador.forEach(e => {
        // if (e.operador){
        //   this.perfiles.push({
        //     value: e.id,
        //     label: e.descripcion
        //   })
        // }
        if (e.operador) {
          //AGREGAMOS UNA LOGICA PARA PUSHEAR LOS PERFILES DEL TIPO DE OPERADOR SI TIENE
          if (e.idTipoOperador == null) {
            this.perfiles.push({
              value: e.id,
              label: e.descripcion
            })
          }
          else {
            var idTipoOperador: number = this.misEmpresas.find(n => n.id == this.empresaSelected).tipoOperador;
            if (e.idTipoOperador == idTipoOperador) {
              this.perfiles.push({
                value: e.id,
                label: e.descripcion
              })
            }
          }
        }
      });
    }
    else {
      this.llenarPerfiles();
    }
  }
  saveUsuario() {
    if (this.passValidator.passErrors) return
    let flag = true;
    let dtoNuevoUsuario = {
      username: this.nombreDeUsuario.toLocaleLowerCase(),
      password: this.contrasenia,
      nombre: this.nombre,
      apellido: this.apellido,
      dni: this.dni,
      correoElectronico: this.email,
      idPerfil: this.perfilSelected,
      idOperador: this.empresaSelected == undefined ? null : (this.empresaSelected == 0 ? null : this.empresaSelected),
      idCliente: this.empresaSelected == undefined ? this.idCliente : (this.empresaSelected == 0 ? this.idCliente : null),
    }

    flag = this.verifyGuardado(dtoNuevoUsuario)

    if (flag) {
      this.showSpinner = true;
      this.svcUsuarios.postPerfilUsuario(dtoNuevoUsuario).subscribe(data => {
        if (data["status"] == 201) {
          this.openSnackBar("Usuario guardado correctamente.")
          this.cerrarModalUpdate();
        }
        else if (data["status"] == 403) {
          this.openSnackBar(data["errors"][0].message)
        } else {
          alert("Ocurrio un error al guardar los datos");
        }
        this.showSpinner = false;
      }, erros => {
        this.cerrarModalUpdate();
      })
    }
  }

  verifyGuardado(dto) {
    if (dto.username.length <= 0) {
      alert("Debe ingresar un usuario")
      return false;
    }
    if (dto.nombre.length <= 0) {
      alert("Debe ingresar nombre")
      return false;
    }
    if (dto.apellido.length <= 0) {
      alert("Debe ingresar apellido")
      return false;
    }
    if (dto.password.length <= 0) {
      alert("Debe ingresar contraseña")
      return false;
    }
    if (dto.correoElectronico.length <= 0) {
      alert("Debe ingresar e-mail")
      return false;
    }

    if (dto.dni.length <= 7) {
      alert("Debe ingresar DNI válido")
      return false;
    }
    if (dto.idPerfil == 0) {
      alert("Debe elegir algún perfil")
      return false;
    }
    if (dto.password != this.REcontrasenia) {
      alert("Las contraseñas ingresadas deben ser iguales.")
      return false;
    }
    if (dto.correoElectronico.length > 0) {
      if (!this.passValidator.validateEmail.test(dto.correoElectronico)) {
        alert("Debe ingresar un e-mail valido")
        return false
      } else {
        return true
      }
    }
    return true;
  }
  getInputTypePw() {
    if (this.showPasswordPw) {
      return 'text';
    }
    return 'password';
  }
  getInputTypeREPw() {
    if (this.showPasswordREPw) {
      return 'text';
    }
    return 'password';
  }
  getIconPw() {
    if (this.showPasswordPw) {
      return 'visibility';
    }
    return 'visibility_off';
  }
  getIconREPw() {
    if (this.showPasswordREPw) {
      return 'visibility';
    }
    return 'visibility_off';
  }
  toggleShowREPassword() {
    this.showPasswordREPw = !this.showPasswordREPw;
  }
  toggleShowPassword() {
    this.showPasswordPw = !this.showPasswordPw;
  }
  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  }
  cerrarModal() {
    this.cerrar.emit("cerrar")
  }
  cerrarModalUpdate() {
    this.cerrarUpdate.emit("cerrarUpdate")
  }
}
